import { useEffect, createRef, useState } from 'react';
import { TabPane, Row } from 'design-react-kit';
import { defineMessages, useIntl } from 'react-intl';
import {
  SideMenu,
  RichTextSection,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import AppuntamentiCardsWrapper from '@redturtle/volto-io-prenoto/components/View/AreaPersonaleView/AppuntamentiCardsWrapper';

const messages = defineMessages({
  title_appuntamenti: {
    id: 'booking_user_bookings',
    defaultMessage: 'Le mie prenotazioni',
  },
});

const Appuntamenti = ({ userId, bookings, loadBookings }) => {
  const intl = useIntl();
  let documentBody = createRef();
  const [sideMenuElements, setSideMenuElements] = useState(null);

  useEffect(() => {
    if (documentBody.current) {
      if (__CLIENT__) {
        setSideMenuElements(documentBody.current);
      }
    }
  }, [documentBody]);

  return (
    <TabPane tabId="1" className="p-3" id="appuntamenti">
      <Row>
        <aside className="col-12 col-lg-3">
          {__CLIENT__ && (
            <SideMenu
              data={sideMenuElements}
              content_uid={userId + '_messaggi'}
            />
          )}
        </aside>
        <section
          id="main-content-section"
          className="col-12 col-lg-8 offset-lg-1 mb-4 mb-lg-5"
          ref={documentBody}
        >
          <RichTextSection
            title={intl.formatMessage(messages.title_appuntamenti)}
            tag_id="listaAppuntamenti"
            show_title={false}
          >
            <h2 className="my-3">
              {intl.formatMessage(messages.title_appuntamenti)}
            </h2>
            <AppuntamentiCardsWrapper
              bookings={bookings}
              defaultItemsDispalyed={5}
              loadBookings={loadBookings}
            />
          </RichTextSection>
        </section>
      </Row>
    </TabPane>
  );
};

export default Appuntamenti;
